import { ModuleData } from '../../Types/containerV2';
import { isVideoModuleContent } from '../../Types/containerV2/modules/video';
import { MediabankFileTypes } from '../../Types/mediabank';
import { getPathWithRootPath } from '../../Services/common';
import BizMediabankVideo from '../BizMediabank/BizMediabankVideo';
import { useContainerContext } from './ContainerContext';
import './VideoModule.scss';

type VideoModuleProps = {
	module: ModuleData;
};

const VideoModule = ({ module }: VideoModuleProps) => {
	if (!isVideoModuleContent(module.content)) {
		return null;
	}

	const { objectType, objectId, finishModule, isEditing } = useContainerContext();

	const { videoUrl, videoThumbnailUrl, videoId, header, descriptionHeader, description, showInPopup } = module.content;

	return (
		<div className='biz-module biz-video-module'>
			{header && <div className='biz-video-module__header'>{header}</div>}
			{isEditing ? (
				<div className='biz-video-module__edit-poster'>
					{videoThumbnailUrl && <img src={getPathWithRootPath(videoThumbnailUrl)} alt='' />}
					<span className='biz-video-module__edit-play-icon' aria-hidden='true'>
						▶
					</span>
				</div>
			) : (
				videoUrl && (
					<BizMediabankVideo
						file={{
							FileUrl: videoUrl,
							Thumbnail: videoThumbnailUrl,
							Id: 0,
							Name: '',
							Description: '',
							Type: MediabankFileTypes.Video.id,
						}}
						fileId={videoId}
						linkedObjectType={objectType}
						linkedObjectId={objectId}
						showInPopup={showInPopup}
						showPoster
						onPlayed={() => finishModule(module.id)}
					/>
				)
			)}
			{(descriptionHeader || description) && (
				<div className='biz-video-module__description'>
					{descriptionHeader && <div className='biz-video-module__description-header'>{descriptionHeader}</div>}
					{description && <div>{description}</div>}
				</div>
			)}
		</div>
	);
};

export default VideoModule;
